module.exports = __webpack_public_path__ + "img/a43bc0c.jpg";